import { LitElement, html, css } from "lit-element";
import { style } from "./style";
import { init, exec } from "pell/src/pell";

// language=CSS
export const StofwareRichEditorStyle = css`
	:host {
		display: inline-block;
		padding: 0 0 70px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		position: relative;
	}

	[contenteditable="true"]:focus {
		outline: none;
	}

	.pell-content {
		border: 1px solid var(--app-lightgrey);
		padding: 20px;
		border-radius: 0 0 3px 3px;
	}

	.pell-actionbar {
		width: 100%;
		display: block;
		padding: 10px 0;
		margin-top: 10px;
		text-align: center;
		border: 1px solid var(--app-lightgrey);
		background-color: var(--app-lightgrey);
		border-radius: 3px 3px 0 0;
	}

	label {
		margin-top: 20px;
	}

	button {
		background: none;
		border: none;
		cursor: pointer;
		max-height: 32px;
		min-width: 32px;
		padding: 8px;
		margin: 0 5px;
		color: var(--app-primary);
		background-color: var(--app-white);
		border-radius: 3px;
		font-size: 14px;
	}
	sw-icon {
		--sw-icon-height: 14px;
	}
	button:hover {
		color: var(--app-accent);
	}
`;

export class StofwareRichEditor extends LitElement {
	static get properties() {
		return {
			name: { type: String },
			label: { type: String },
			editor: { type: Object },
			data: { type: Object },
			html: { type: Object },
			required: { type: Boolean },
			disabled: { type: Boolean }
		};
	}

	firstUpdated(_changedProperties) {
		super.firstUpdated(_changedProperties);
		const editorElement = this.shadowRoot.getElementById("editorjs");

		this.editor = init({
			element: editorElement,
			defaultParagraphSeparator: "div",
			actions: [
				"bold",
				"italic",
				"underline",
				"heading1",
				"heading2",
				{
					name: "paragraph",
					icon: '<sw-icon icon="paragraph"></sw-icon>'
				},
				{
					name: "olist",
					icon: '<sw-icon icon="list-ol"></sw-icon>'
				},
				{
					name: "ulist",
					icon: '<sw-icon icon="list-ul"></sw-icon>'
				},
				{
					name: "quote",
					icon: '<sw-icon icon="quote-right"></sw-icon>'
				},
				{
					name: "image",
					icon: '<sw-icon icon="image" set="far"></sw-icon>'
				},
				{
					name: "link",
					icon: '<sw-icon icon="link"></sw-icon>'
				},
				{
					name: "justifyLeft",
					icon: '<sw-icon icon="align-left"></sw-icon>',
					title: "Custom Action",
					result: () => document.execCommand("justifyLeft")
				},
				{
					name: "justifyCenter",
					icon: '<sw-icon icon="align-center"></sw-icon>',
					title: "Custom Action",
					result: () => document.execCommand("justifyCenter")
				},
				{
					name: "justifyRight",
					icon: '<sw-icon icon="align-right"></sw-icon>',
					title: "Custom Action",
					result: () => document.execCommand("justifyRight")
				}
			],
			onChange: html => {
				this.html = html;
			}
		});
	}

	updated(_changedProperties) {
		super.updated(_changedProperties);
		if (_changedProperties.has("data")) {
			this.editor.content.innerHTML = this.data;
			this.html = this.data;
		}
	}

	static get styles() {
		return [style, StofwareRichEditorStyle];
	}

	render() {
		return html`
			<label>${this.label}</label>
			<div id="editorjs"></div>
			<textarea hidden name="${this.name}">${this.html}</textarea>
		`;
	}
}

customElements.define("rich-editor", StofwareRichEditor);
